/**
 * Copyright 2019, OpenCensus Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { randomSpanId, randomTraceId } from '../../common/id-util';
/** Propagation implementation that does not set or get headers. */
var NoHeadersPropagation = /** @class */ (function () {
    function NoHeadersPropagation() {
    }
    NoHeadersPropagation.prototype.extract = function (getter) {
        return null;
    };
    NoHeadersPropagation.prototype.inject = function (setter, spanContext) { };
    NoHeadersPropagation.prototype.generate = function () {
        return { traceId: randomTraceId(), spanId: randomSpanId() };
    };
    return NoHeadersPropagation;
}());
export { NoHeadersPropagation };
//# sourceMappingURL=no_headers_propagation.js.map